import Vuex from 'vuex';
import Vue from 'vue'
Vue.use(Vuex)
const moduleA = {
  state: {},
  mutations: {},
  actions: {},
  getters: {}
};

const store = new Vuex.Store({
  // 相当于vue  中的data
  state: {
    msg: 'hellow  vuex',
    loginDialogVisible: false,
    hideLoginDialog: false,
    priceCode: '',
    priceDialogVisible: false,
    userInfoRefreshFlag: 0
  },
  // 相当于vue computed
  getters: {
    getMsg () {
      return store.state.msg + 'so good';
    }
  },
  // 相当于vue中的method
  mutations: {
    addPreFix (state) {
      state.msg = 'msg:' + state.msg;
    },
    showLoginDialog: function (state) {
      state.loginDialogVisible = !state.loginDialogVisible
    },
    hideLoginDialog: function (state) {
      state.hideLoginDialog = !state.hideLoginDialog
    },
    showPriceDialog: function (state, code) {
      state.priceDialogVisible = !state.priceDialogVisible;
      state.priceCode = code
    },
    refreshUserInfo: function (state) {
      state.userInfoRefreshFlag = Math.random();
    }
  },
  // 和mutations 类似，但是可以异步操作
  Actions: {},
  modules: {
    a: moduleA
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/config/store.js